<template>
  <div>
    <user-address-sidebar />
    <user-personal-data-sidebar />
    <new-appointment-sidebar />
    <new-lead-sidebar v-if="profileType == type.PROFILE_TYPE_CONSULTANT" />
    <lead-tag-sidebar />
    <roadshow-score-review-sidebar />
    <save-consultant-basic-information-sidebar
      v-if="profileType == type.PROFILE_TYPE_CONSULTANT"
    />
    <request-specialist-sidebar
      :visible="requestSpecialistSidebarVisible"
      :customer="customer"
      :allow-create="canRequestSpecialist"
      @change="handleRequestSpecialistSidebarChange"
      @hidden="handleRequestSpecialistSidebarHidden"
      @refresh="handleRequestSpecialistSidebarRefresh"
    />
    <div v-if="loading" class="d-flex justify-content-center m-2">
      <b-spinner variant="primary" />
    </div>
    <div v-else-if="customer">
      <b-card class="about-card abbout-card-top">
        <!-- about -->
        <b-row class="justify-content-center m-1">
          <b-form-file
            ref="pic"
            v-model="profilePic"
            accept=".jpg,.jpeg,.png,.bmp,.tiff"
            style="display: none"
            @input="uploadPic"
          />
          <b-avatar
            v-if="customer.profile_picture_url"
            :src="customer.profile_picture_url"
            size="8rem"
            badge
            badge-variant="profile"
          >
            <template #badge>
              <b-button
                class="btn-icon"
                variant="flat"
                style="padding: 0; color: white"
                @click="$refs.pic.$el.querySelector('input[type=file]').click()"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>
            </template>
          </b-avatar>
          <b-avatar
            v-else
            src="~@/assets/images/logo/futuro.svg"
            size="8rem"
            badge
            badge-variant="profile"
          >
            <template #badge>
              <b-button
                class="btn-icon"
                variant="flat"
                style="padding: 0; color: white"
                @click="$refs.pic.$el.querySelector('input[type=file]').click()"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>
            </template>
          </b-avatar>
        </b-row>
        <b-row class="justify-content-center">
          <h4 class="mb-75">
            {{ customer.name }}
          </h4>
        </b-row>
        <b-row class="justify-content-center">
          <span>{{ customer.email }}</span>
        </b-row>
        <b-row class="justify-content-center">
          <span>{{ customer.cell_phone | formatPhone }}</span>
        </b-row>
        <b-row class="justify-content-center m-1">
          <b-badge
            v-if="customer.is_vip"
            pill
            class="vip-badge mr-2"
            style="width: 120px"
          >
            <b-row class="justify-content-center align-items-center">
              <img
                class="img_icon"
                style="margin-right: 10px"
                src="~@/assets/images/svg/icn_premium.svg"
              />
              <span style="color: #dba800">Cliente VIP</span>
            </b-row>
          </b-badge>
          <b-badge
            v-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_HOT ||
              customer.customer_status_id == status.CUSTOMER_STATUS_LEAD_PN_HOT
            "
            pill
            variant="hot-user"
          >
            <img src="~@/assets/images/svg/icn_hot_active.svg" width="10" />
            Quente
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_COLD ||
              customer.customer_status_id == status.CUSTOMER_STATUS_LEAD_PN_COLD
            "
            pill
            variant="cold-user"
          >
            <img src="~@/assets/images/svg/icn_cold_active.svg" width="10" />
            Frio
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_DISINTERESTED ||
              customer.customer_status_id ==
                status.CUSTOMER_STATUS_LEAD_PN_DISINTERESTED
            "
            pill
            variant="disinterested-user"
          >
            <img
              src="~@/assets/images/svg/icn_disinterested_active.svg"
              width="12"
            />
            Desinteressado
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_EA ||
              customer.customer_status_id == status.CUSTOMER_STATUS_LEAD_PN_EA
            "
            pill
            variant="scheduled_interview-user"
          >
            Entrevista agendada
          </b-badge>
          <b-badge
            v-else-if="customer.customer_status_id == status.CUSTOMER_STATUS_EF"
            pill
            variant="done_interview-user"
          >
            Entrevista feita
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_LEAD_PN_EF
            "
            pill
            variant="done_interview-lead-consultant"
          >
            Entrevista PN feita
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_SUPPORT
            "
            pill
            variant="support-user"
          >
            <img src="~@/assets/images/svg/icn_support.svg" width="10" />
            Suporte
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_BASIC_SUB
            "
            pill
            variant="basic_sub-user"
          >
            <img src="~@/assets/images/svg/icn_user_disable.svg" width="10" />
            Básico
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_ESSENTIAL_SUB
            "
            pill
            variant="essential_sub-user"
          >
            <img src="~@/assets/images/svg/icn_essential.svg" width="12" />
            Essencial
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_ELITE_SUB
            "
            pill
            variant="elite_sub-user"
          >
            <img src="~@/assets/images/svg/icn_premium.svg" width="12" />
            Elite
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_OFF_FUTURO
            "
            pill
            variant="off_futuro-user"
          >
            off-Futuro
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_ELITE_SUB
            "
            pill
            variant="premium-user"
          >
            <img src="~@/assets/images/svg/icn_premium.svg" width="12" />
            Premium
          </b-badge>
          <b-badge
            v-else-if="customer.customer_status_id == status.CUSTOMER_STATUS_EP"
            pill
            variant="done_interview-user"
          >
            Entrevista paga
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id ==
              status.CUSTOMER_STATUS_FINANCIAL_SOLUTION
            "
            pill
            variant="done_financial_solution-user"
          >
            Solução financeira
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id ==
              status.CUSTOMER_STATUS_CANCELED_SUBSCRIPTION
            "
            pill
            variant="canceled_subscription-user"
          >
            Assinatura cancelada
          </b-badge>
          <b-badge
            v-else-if="customer.customer_status_id == status.CUSTOMER_STATUS_GESTAO"
            pill
            variant="gestao-user"
          >
            Gestão financeira
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id ==
              status.CUSTOMER_STATUS_WAIT_CONTRACT_PAYMENT
            "
            pill
            variant="wait_contract_payment-user"
          >
            Aguardando contrato rodar
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id == status.CUSTOMER_STATUS_LEAD_PN_SOLIDES
            "
            pill
            variant="done_financial_solution-user"
          >
            Sólides
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id ==
              status.CUSTOMER_STATUS_LEAD_PN_DISQUALIFIED
            "
            pill
            variant="done_financial_solution-user"
          >
            Desclassificado
          </b-badge>
          <b-badge
            v-else-if="
              customer.customer_status_id ==
              status.CUSTOMER_STATUS_LEAD_PN_TRANSFORMED
            "
            pill
            variant="transformed-user"
          >
            Transformado em PN
          </b-badge>
          <b-badge 
            v-else-if="
              customer.customer_status_id ==
              status.CUSTOMER_STATUS_PA
            "
            pill variant="undefined-user">
            Parceria Agendada
          </b-badge>
          <b-badge v-else pill variant="undefined-user">
            A classificar
          </b-badge>
        </b-row>
        <b-row
          v-if="customer.specialist === 1 || (leadPn && leadPn.specialist === 1)"
          class="justify-content-center m-1"
        >
          <b-badge
            pill
            style="
              background-color: transparent;
              border: 1px solid rgb(55 172 242);
              color: rgb(55 172 242);
            "
          >
            <strong v-if="profileType == type.PROFILE_TYPE_CUSTOMER"
              >Cliente de colaboração</strong
            >
            <strong v-else>Lead de colaboração</strong>
            -
            {{ customer ? customer.consultant_name : "" }}
          </b-badge>
        </b-row>
        <b-row
          v-if="customer.is_share === 1"
          class="justify-content-center m-1"
        >
          <b-badge
            pill
            style="
              background-color: transparent;
              border: 1px solid rgb(55 172 242);
              color: rgb(55 172 242);
            "
          >
            <strong>Diagnóstico - {{ shareDepartmentLabel }}</strong>
          </b-badge>
        </b-row>
        <b-row
          v-if="profileType == type.PROFILE_TYPE_CUSTOMER"
          class="text-center m-1"
        >
          <b-col cols="12">
            Valor LTV: <b>{{ customer.ltv_value | toCurrency }}</b>
            <br />
            Poupa:
            <b>
              <span
                v-if="
                  customer.customer_additionals &&
                  customer.customer_additionals.monthly_savings
                "
              >
                {{ customer.customer_additionals.monthly_savings | toCurrency }}
              </span>
              <span v-else> R$ 0,00 </span>
            </b>
          </b-col>
        </b-row>
        <template
          v-if="
            profileType == type.PROFILE_TYPE_CUSTOMER ||
            profileType == type.PROFILE_TYPE_LEAD
          "
        >
          <b-row
            v-if="hasInterview && canManageInterview && isOwnerDeleted"
            class="justify-content-center mx-1 mb-0 mt-1"
          >
            <small class="font-weight-bold text-warning text-center">
              O dono deste cliente está inativo no Oráculo.<br />
              A geração do contrato estará indisponível. Acione o suporte CX para regularização.
            </small>
          </b-row>
          <b-row
            v-if="hasInterview && canManageInterview"
            class="justify-content-center m-1"
          >
            <small
              class="font-weight-bold text-danger m-1 text-center"
              v-if="interviewAccessBlocked"
            >
              Esta entrevista já está sendo acessada neste momento por outro
              navegador/dispositivo.
              <br />
              Aguarde 5 minutos após o acesso ser encerrado e tente novamente.
            </small>
            <b-button
              id="openInterview"
              target="_blank"
              variant="outline-primary"
              block
              @click="openInterview(true)"
              :disabled="interviewAccessBlocked"
            >
              Editar entrevista
            </b-button>
          </b-row>
          <b-row
            v-if="!hasInterview && hasAppointment && !interviewAccessBlocked"
            class="justify-content-center m-1"
          >
            <b-button
              target="_blank"
              variant="outline-primary"
              block
              @click="convertInterview()"
            >
              Transformar em entrevista
            </b-button>
          </b-row>
          <b-row
            v-if="canReadInterview && (hasPreInterview || hasAppointment)"
            class="justify-content-center m-1"
          >
            <b-button
              target="_blank"
              variant="outline-primary"
              block
              @click="openInterview(false)"
            >
              Visualizar entrevista
            </b-button>
          </b-row>
          <b-row class="justify-content-center m-1">
            <b-button
              v-if="canCreateAppointment"
              variant="outline-primary"
              block
              @click="createAppointment"
            >
              Agendar reunião
            </b-button>
          </b-row>
          <b-row v-if="!hasInterview && !aiPreInterviewDone" class="justify-content-center m-1">
            <b-button
              variant="outline-primary"
              :disabled="loadingSendInterviewByWhatsapp"
              block
              @click="sendInterviewByWhatsapp"
            >
              <template v-if="loadingSendInterviewByWhatsapp">
                <b-spinner v-if="loadingSendInterviewByWhatsapp" small />
                Aguarde...
              </template>
              <template v-else>
                <span v-if="hasPreInterview">Re-enviar</span>
                <span v-else>Enviar</span>
                pré-entrevista por whatsapp
              </template>
            </b-button>
          </b-row>
          <b-row v-if="!hasInterview && !aiPreInterviewDone" class="justify-content-center m-1">
            <b-button
              variant="outline-primary"
              :disabled="loadingSendInterviewByEmail"
              block
              @click="sendInterviewByEmail"
            >
              <template v-if="loadingSendInterviewByEmail">
                <b-spinner v-if="loadingSendInterviewByEmail" small />
                Aguarde...
              </template>
              <template v-else>
                <span v-if="hasPreInterview">Re-enviar</span>
                <span v-else>Enviar</span>
                pré-entrevista por email
              </template>
            </b-button>
          </b-row>
          <b-row
            v-if="this.customer.customer_type_id == 2"
            class="justify-content-center m-1"
          >
            <b-button variant="outline-primary" block @click="generateXMoment">
              <template> Apresentação comercial do MX </template>
            </b-button>
          </b-row>
          <b-row
            v-if="showRequestPriorityAction"
            class="justify-content-center m-1"
          >
            <b-button
              variant="outline-primary"
              block
              @click="openRequestSpecialistSidebar"
            >
              Solicitar atendimento prioritário
            </b-button>
          </b-row>
          <b-row
            v-if="hasRequestSpecialistRequests"
            class="justify-content-center m-1"
          >
            <b-col cols="12" class="px-0">
              <div class="border rounded p-1">
                <div class="font-weight-bolder mb-1">
                  Atendimento prioritário mais recente
                </div>

                <div
                  v-if="latestRequestSpecialistRequest"
                  class="border rounded p-1 mb-1"
                >
                  <div class="d-flex justify-content-between align-items-start flex-wrap">
                    <div class="mr-1">
                      <div>{{ latestRequestSpecialistRequest.department_name || "-" }}</div>
                      <div class="text-muted small">
                        Solicitado em {{ formatRequestSpecialistDateTime(latestRequestSpecialistRequest.requested_at) }}
                      </div>
                    </div>
                    <b-badge :variant="requestSpecialistStatusVariant(latestRequestSpecialistRequest.status)">
                      {{ requestSpecialistStatusLabel(latestRequestSpecialistRequest.status) }}
                    </b-badge>
                  </div>

                  <div class="small mt-1">
                    <div><strong>Especialista:</strong> {{ latestRequestSpecialistRequest.specialist_label || "-" }}</div>
                    <div><strong>Atribuído em:</strong> {{ formatRequestSpecialistDateTime(latestRequestSpecialistRequest.assigned_at) }}</div>
                  </div>
                </div>

                <b-button
                  v-if="canRequestSpecialist"
                  variant="link"
                  class="p-0"
                  @click="openRequestSpecialistSidebar"
                >
                  Ver histórico completo
                </b-button>
              </div>
            </b-col>
          </b-row>
        </template>
        <template
          v-if="
            profileType == type.PROFILE_TYPE_CONSULTANT &&
            customer.customer_status_id !=
              status.CUSTOMER_STATUS_LEAD_PN_TRANSFORMED
          "
        >
          <b-row
            class="justify-content-center m-1"
            v-if="!hasRecruitment || (hasRecruitment && !hasAnsweredRoadShow)"
          >
            <b-button
              variant="outline-primary"
              block
              @click="createAppointment"
            >
              Agendar uma entrevista
            </b-button>
          </b-row>
          <b-row v-if="hasRoadshowScore" class="justify-content-center m-1">
            <b-button
              variant="outline-primary"
              block
              @click="openRoadshowScoreReviewSidebar"
            >
              Revisar score do RoadShow
            </b-button>
          </b-row>
          <b-row class="justify-content-center m-1">
            <b-button
              variant="outline-primary"
              block
              @click="openIndividualInterview"
            >
              Acessar Entrevista Individual
            </b-button>
          </b-row>
          <b-row class="justify-content-center m-1">
            <b-button
              v-if="hasAnsweredRoadShow"
              variant="outline-primary"
              block
              @click="copyRoadshow"
            >
              Copiar mensagem do RoadShow
            </b-button>
          </b-row>
          <b-row v-if="isLeadPnDisqualified" class="justify-content-center m-1">
            <b-button
                variant="outline-primary"
                block
                @click="handleReactivateLeadPn"
            >
                Reativar Lead PN
            </b-button>
        </b-row>
        </template>
        <template v-if="hasRecruitment">
          <b-row class="justify-content-center m-1 mt-2">
            <b-col cols="12" class="px-0">
              <b-row>
                <b-col v-if="leadPn.recruitment.is_overdue" cols="6">
                  <b-row>
                    <b-col cols="12" style="margin-bottom: 4px">
                      <span>Alerta</span>
                    </b-col>
                    <b-col
                      cols="auto"
                      class="mb-1 aligin-items-center d-flex text-danger"
                    >
                      <feather-icon
                        icon="AlertTriangleIcon"
                        size="20"
                        style="margin-right: 4px"
                      />
                      <span>Prazo terminado</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="12" style="margin-bottom: 4px">
                      <span>Etapa do recrutamento</span>
                    </b-col>
                    <b-col cols="auto" class="mb-1">
                      <span
                        ><b>{{ leadPn.recruitment.stage_name }}</b></span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="12" style="margin-bottom: 4px">
                      <span>Prazo na etapa</span>
                    </b-col>
                    <b-col cols="auto" class="mb-1">
                      <span
                        :class="{
                          'text-danger': leadPn.recruitment.is_overdue,
                        }"
                        ><b>{{
                          leadPn.recruitment.recruitment_stage_days
                        }}</b></span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col cols="12" style="margin-bottom: 4px">
                      <span>Dono do Lead</span>
                    </b-col>
                    <b-col cols="auto" class="mb-1" v-if="leadPn.added">
                      <span
                        ><b>{{ leadPn.added.name }}</b></span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="hasRoadshowScore" cols="6">
                  <b-row>
                    <b-col cols="12" style="margin-bottom: 4px">
                      <span>Score do RoadShow</span>
                    </b-col>
                    <b-col cols="auto" class="mb-1">
                      <span
                        ><b>{{
                          formatScore(leadPn.recruitment.roadshow_score_total)
                        }}</b>
                        pts</span
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="hasInterviewScore" cols="6">
                  <b-row>
                    <b-col cols="12" style="margin-bottom: 4px">
                      <span>Score da Entrevista Individual</span>
                    </b-col>
                    <b-col cols="auto" class="mb-1">
                      <span
                        ><b>{{
                          formatScore(leadPn.recruitment.interview_score_total)
                        }}</b>
                        pts</span
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <b-row id="actions" class="justify-content-between m-1 mt-2">
          <b-col cols="12" class="px-0">
            <b-row>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" class="mb-1">
                    <span>Contato</span>
                  </b-col>
                  <b-col cols="auto" class="mb-1">
                    <b-button
                      variant="outline-whats"
                      size="sm"
                      @click="openWhatsapp"
                    >
                      <img
                        src="~@/assets/images/svg/icn_green_whats.svg"
                        width="15"
                      />
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="pl-0 mb-1">
                    <b-button
                      v-if="customer.email"
                      variant="outline-email"
                      size="sm"
                      @click="sendEmail"
                    >
                      <img
                        src="~@/assets/images/svg/icn_email.svg"
                        width="15"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-row>
                  <b-col cols="12" class="mb-1">
                    <span>Lembrar</span>
                  </b-col>
                  <b-col cols="auto">
                    <div class="text-wrap">
                      <b-form-input
                        v-model="call_reminder"
                        class="form-control"
                        type="datetime-local"
                        @blur="saveCallReminder(call_reminder, customer.id)"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <template v-if="canChangeStatus">
            <b-col
              v-if="
                profileType == type.PROFILE_TYPE_CUSTOMER ||
                profileType == type.PROFILE_TYPE_LEAD
              "
              cols="12"
              class="px-0"
            >
              <span>Alterar status</span>
            </b-col>
            <template v-if="profileType == type.PROFILE_TYPE_CONSULTANT">
              <b-col cols="12" class="px-0">
                <span>Tags</span>
                <b-button
                  class="btn-icon"
                  variant="flat"
                  style="padding: 0; margin-left: 3px; color: #33af58"
                  @click="editTags"
                >
                  <feather-icon icon="PlusCircleIcon" size="14" />
                </b-button>
              </b-col>

              <b-col cols="12" class="px-0">
                <template v-for="(tag, index) in customer.customer_tags">
                  <b-badge
                    pill
                    class="mr-1 mb-1"
                    :class="isDesalinhamento(tag.name) ? 'tag-desalinhamento' : ''"
                    :variant="tagVariant(tag.name)"
                    :style="tagStyle(tag.name)"
                  >
                    <feather-icon
                      v-if="isDesalinhamento(tag.name)"
                      icon="AlertOctagonIcon"
                      size="11"
                      class="mr-25"
                    />
                    #{{ tag.name }}
                  </b-badge>
                </template>
              </b-col>
            </template>
            <b-col cols="12" class="px-0">
              <b-row class="mt-1">
                <template
                  v-if="
                    profileType == type.PROFILE_TYPE_CUSTOMER ||
                    profileType == type.PROFILE_TYPE_LEAD
                  "
                >
                  <b-col cols="auto">
                    <b-button
                      id="customer-hot"
                      variant="outline-danger"
                      size="sm"
                      @click="setStatus(status.CUSTOMER_STATUS_HOT)"
                    >
                      <img
                        src="~@/assets/images/svg/icn_hot_active.svg"
                        width="15"
                      />
                    </b-button>
                    <b-tooltip
                      target="customer-hot"
                      title="Esquentar"
                      placement="top"
                      boundary="document"
                    />
                  </b-col>
                  <b-col cols="auto">
                    <b-button
                      id="customer-cold"
                      variant="outline-cold"
                      size="sm"
                      @click="setStatus(status.CUSTOMER_STATUS_COLD)"
                    >
                      <img
                        src="~@/assets/images/svg/icn_cold_active.svg"
                        width="15"
                      />
                    </b-button>
                  </b-col>
                  <b-tooltip
                    target="customer-cold"
                    title="Esfriar"
                    placement="top"
                    boundary="document"
                  />
                  <b-col cols="auto">
                    <b-button
                      id="customer-disinterested"
                      variant="outline-warning"
                      size="sm"
                      @click="setStatus(status.CUSTOMER_STATUS_DISINTERESTED)"
                    >
                      <img
                        src="~@/assets/images/svg/icn_disinterested_active.svg"
                        width="15"
                      />
                    </b-button>
                    <b-tooltip
                      target="customer-disinterested"
                      title="Desinteressado"
                      placement="top"
                      boundary="document"
                    />
                  </b-col>
                </template>
                <template v-if="profileType == type.PROFILE_TYPE_CONSULTANT">
                  <b-col cols="auto" />
                </template>
              </b-row>
            </b-col>
          </template>
          <template
            v-if="
              profileType == type.PROFILE_TYPE_CUSTOMER ||
              profileType == type.PROFILE_TYPE_LEAD
            "
          >
            <b-row>
              <b-col cols="12" class="px-0 mt-1 mb-1">
                <span>Status da pré-entrevista</span>
              </b-col>
              <b-col cols="12" class="px-0">
                <div class="d-flex align-items-center gap-2">
                  <b-badge :variant="interviewStatusData.badgeVariant">{{
                    interviewStatusData.statusLabel
                  }}</b-badge>
                </div>
              </b-col>
            </b-row>
          </template>
        </b-row>
        <!-- Indicado por - Apenas PN ou Admin -->
        <b-row
          v-if="customer.referrer_customer_name && canViewReferrer"
          class="justify-content-center mt-2"
        >
          <b-col cols="12" class="text-center">
            <span class="text-muted">Indicado por: </span>
            <router-link
              :to="{
                name: 'profile-comments',
                params: { id: customer.referrer_customer_id },
              }"
            >
              {{ customer.referrer_customer_name }}
            </router-link>
          </b-col>
        </b-row>
        <b-row
          v-if="profileType == type.PROFILE_TYPE_CUSTOMER && hasOpenFinance"
          class="justify-content-center mt-2 px-1"
        >
          <b-col cols="12" class="px-0">
            <b-button
              variant="outline-danger"
              block
              :disabled="loadingDeleteOpenFinance"
              @click="confirmDeleteOpenFinance"
            >
              <b-spinner v-if="loadingDeleteOpenFinance" small class="mr-50" />
              <feather-icon v-else icon="TrashIcon" size="14" class="mr-50" />
              Remover contas Open Finance
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-row class="card-separator">
        <b-col md="8">
          <img src="~@/assets/images/svg/icn_blue_user.svg" width="14" />
          Detalhes pessoais
        </b-col>
        <b-col md="4" class="text-right">
          <b-button
            class="btn-icon"
            variant="flat"
            style="padding: 0"
            @click="editPersonalData"
          >
            <img src="~@/assets/images/svg/icn_pencil.svg" width="14" />
          </b-button>
        </b-col>
      </b-row>
      <b-card
        v-if="
          profileType == type.PROFILE_TYPE_CUSTOMER ||
          profileType == type.PROFILE_TYPE_LEAD
        "
        class="about-card abbout-card-middle"
      >
        <b-row class="mb-1">
          <b-col md="6" class="text-muted">{{
            customer.cnpj ? "CNPJ:" : "CPF:"
          }}</b-col>
          <b-col md="6" class="text-right">
            {{ customer.cpf ? customer.cpf : customer.cnpj | cpfCnpj }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> RG: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.rg }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Data de nascimento: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.birth_date | onlyDate }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Profissão: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.occupation }}
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="6" class="text-muted"> Faixa de Renda: </b-col>
          <b-col md="6" class="text-right">
            <span
              v-if="
                customer.customer_additionals &&
                customer.customer_additionals.income_bracket
              "
            >
              {{ customer.customer_additionals.income_bracket }}
            </span>
            <span
              v-else-if="
                customer.customer_additionals &&
                customer.customer_additionals.income &&
                customer.customer_additionals.income.name
              "
            >
              {{ customer.customer_additionals.income.name }}
            </span>
          </b-col>
        </b-row>
      </b-card>
      <b-card
        v-if="profileType == type.PROFILE_TYPE_CONSULTANT && leadPn"
        class="about-card abbout-card-middle"
      >
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Potencial: </b-col>
          <b-col md="6" class="text-right">
            {{ leadPn.consultant_lead_potential }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Profissão: </b-col>
          <b-col v-if="leadPn.occupation" md="6" class="text-right">
            {{ leadPn.occupation.name }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Formação: </b-col>
          <b-col v-if="leadPn.school_level" md="6" class="text-right">
            {{ leadPn.school_level.name }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Objetivo: </b-col>
          <b-col md="6" class="text-right">
            {{ leadPn.goal | leadGoal }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Consultor responsável: </b-col>
          <b-col
            v-if="leadPn.consultant"
            md="6"
            class="text-right text-capitalize"
          >
            {{ leadPn.consultant.name }}
          </b-col>
        </b-row>

        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Franquia: </b-col>
          <b-col v-if="leadPn.consultant" md="6" class="text-right">
            {{ leadPn.consultant.leader_franchise_name | franchiseDisplay(leadPn.consultant.name) }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Já empreendeu: </b-col>
          <b-col md="6" class="text-right">
            {{ leadPn.was_entrepreneur ? "Sim" : "Não" }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Origem: </b-col>
          <b-col md="6" class="text-right">
            {{ leadPn.origin | leadOrigin }}
          </b-col>
        </b-row>
      </b-card>
      <b-row class="card-separator">
        <b-col md="8">
          <feather-icon icon="UsersIcon" size="18" />
          Dono do cliente
        </b-col>
      </b-row>
      <b-card
        v-if="
          profileType == type.PROFILE_TYPE_CUSTOMER ||
          profileType == type.PROFILE_TYPE_LEAD
        "
        class="about-card abbout-card-middle"
      >
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Nome: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.consultant_name }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Nível: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.consultant_role }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Franquia: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.consultant_franchise_name | franchiseDisplay(customer.consultant_name) }}
          </b-col>
        </b-row>
      </b-card>
      <b-row class="card-separator">
        <b-col md="6">
          <img src="~@/assets/images/svg/icn_local.svg" width="14" />
          Localização
        </b-col>
        <b-col md="6" class="text-right">
          <b-button
            class="btn-icon"
            variant="flat"
            style="padding: 0"
            @click="editAddress"
          >
            <img src="~@/assets/images/svg/icn_pencil.svg" width="14" />
          </b-button>
        </b-col>
      </b-row>
      <b-card class="about-card abbout-card-bottom">
        <template
          v-if="
            profileType == type.PROFILE_TYPE_CUSTOMER ||
            profileType == type.PROFILE_TYPE_LEAD
          "
        >
          <b-row class="mb-1 justify-content-left">
            <b-col md="12" class="text-muted"> Endereço: </b-col>
            <b-col md="12">
              {{ customer.address_street }}, {{ customer.address_number }}
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="6" class="text-muted"> CEP: </b-col>
            <b-col md="6" class="text-right">
              {{ customer.address_cep | cep }}
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="6" class="text-muted"> Bairro: </b-col>
            <b-col md="6" class="text-right">
              {{ customer.address_district }}
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="12" class="text-muted"> Complemento: </b-col>
            <b-col md="12">
              {{ customer.address_complement }}
            </b-col>
          </b-row>
        </template>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Cidade: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.address_city }}
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col md="6" class="text-muted"> Estado: </b-col>
          <b-col md="6" class="text-right">
            {{ customer.address_state }}
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BAvatar,
  BBadge,
  BButton,
  BSpinner,
  BFormFile,
  BTooltip,
  BFormGroup,
} from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import NewAppointmentSidebar from "@/modules/appointment/components/NewAppointmentSidebar";
import NewLeadSidebar from "@/modules/lead/components/NewLeadSidebar";
import SaveConsultantBasicInformationSidebar from "@/modules/consultant/components/SaveConsultantBasicInformationSidebar";
import * as appointmentTypes from "@/modules/appointment/store/types";
import * as sharedTypes from "@/modules/shared/store/types";
import * as customerStatus from "@/constants/customers_status";
import * as leadTypes from "@/modules/lead/store/types";
import { createWppInterviewMessage } from "@/helpers/whatsapp_messages";
import * as profileTypes from "@/constants/profile";
import * as customerTypes from "@/constants/customers_types";
import * as consultantTypes from "@/modules/consultant/store/types";
import * as recruitmentTypes from "@/modules/recruitment/store/types";
import { LEAD_TYPE_PPN } from "@/constants/lead";
import useAppConfig from "@core/app-config/useAppConfig";
import LeadTagSidebar from "@/modules/recruitment/components/LeadTagSidebar.vue";
import RoadshowScoreReviewSidebar from "@/modules/recruitment/components/RoadshowScoreReviewSidebar.vue";
import { leadPn } from "@/helpers/modalInfo";
import { SET_CALL_REMINDER } from "../../customer/store/types";
import UserPersonalDataSidebar from "../components/UserPersonalDataSidebar";
import * as types from "../store/types";
import * as accountTypes from "@/modules/account/store/types";
import UserAddressSidebar from "../components/UserAddressSidebar";
import vSelect from "vue-select";
import {
  READ_ACTION,
  CREATE_ACTION,
  INTERVIEW_RESOURCE,
  APPOINTMENT,
  MANAGE_ACTION,
  REQUEST_SPECIALIST_MENU,
} from "@/constants/resources";
import { isPnRole, isBackofficeRole, SPECIALIST_DEPT_NAMES } from "@/constants/auth";
import { VMoney } from "v-money";
import RequestSpecialistSidebar from "@/modules/customer/components/RequestSpecialistSidebar.vue";
import {
  getRequestSpecialistStatusLabel,
  getRequestSpecialistStatusVariant,
} from "@/constants/requestSpecialist";

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    BButton,
    BSpinner,
    BFormFile,
    BFormGroup,
    UserAddressSidebar,
    UserPersonalDataSidebar,
    NewAppointmentSidebar,
    NewLeadSidebar,
    SaveConsultantBasicInformationSidebar,
    BTooltip,
    LeadTagSidebar,
    RoadshowScoreReviewSidebar,
    vSelect,
    RequestSpecialistSidebar,
  },
  directives: {
    money: VMoney,
  },
  props: {
    profileType: String,
    reload: Function,
  },
  setup() {
    const { skin } = useAppConfig();

    return { toast: useToast(), skin };
  },
  data() {
    return {
      loading: false,
      userType: types.CUSTOMER,
      frontEndUrl: process.env.VUE_APP_FRONT_END_URL,
      appifyUrl: process.env.VUE_APP_URL,
      roadShowUrl: process.env.VUE_APP_ROADSHOW_FRONTEND_URL,
      profilePic: undefined,
      loadingSendInterviewByWhatsapp: false,
      loadingSendInterviewByEmail: false,
      leadPn: undefined,
      call_reminder: undefined,
      timer: null,
      interviewAccessBlocked: false,
      interviewStatus: "empty",
      isLeadPnDisqualified: false,
      requestSpecialistSidebarVisible: false,
      hasOpenFinance: false,
      loadingDeleteOpenFinance: false,
      aiPreInterviewStatus: null,
    };
  },
  computed: {
    ...mapGetters({
      customer: types.CUSTOMER,
      currentUser: accountTypes.USER,
    }),
    shareDepartmentLabel() {
      const deptId = this.currentUser?.department_id
      return SPECIALIST_DEPT_NAMES[deptId] || 'Holding'
    },
    status() {
      return customerStatus;
    },
    hasPreInterview() {
      return this.customer.interviews?.length > 0;
    },
    hasInterview() {
      return (
        this.customer.interviews?.length > 0 && this.customer.interviews[0].is_interview
      );
    },
    // Pré-Entrevista por IA já concluída (ou reaberta preservando resultados):
    // esconde o (re)envio da pré-entrevista comum para não confundir os fluxos.
    aiPreInterviewDone() {
      return ["concluida", "reaberta"].includes(this.aiPreInterviewStatus?.status);
    },
    hasAppointment() {
      return this.customer.appointment?.length > 0;
    },
    type() {
      return profileTypes;
    },
    canChangeStatus() {
      if (
        this.customer?.customer_status_id == customerStatus.CUSTOMER_STATUS_EA ||
        this.customer?.customer_status_id == customerStatus.CUSTOMER_STATUS_EF ||
        this.customer?.customer_status_id == customerStatus.CUSTOMER_STATUS_EP ||
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_SUPPORT ||
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_BASIC_SUB ||
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_ESSENTIAL_SUB ||
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_ELITE_SUB ||
        this.customer?.customer_type_id == customerTypes.CUSTOMER ||
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_LEAD_PN_TRANSFORMED ||
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_LEAD_PN_DISQUALIFIED || 
        this.customer?.customer_status_id == 
          customerStatus.CUSTOMER_STATUS_OFF_FUTURO || 
        this.customer?.customer_status_id ==
          customerStatus.CUSTOMER_STATUS_PREMIUM
      ) {
        return false;
      }
      return true;
    },
    hasRecruitment() {
      return (
        this.leadPn &&
        this.leadPn.recruitment &&
        this.leadPn.recruitment.created_at
      );
    },
    hasAnsweredRoadShow: function () {
      return (
        this.hasRecruitment &&
        this.leadPn.recruitment.recruitment_stage_id >= 2 &&
        !this.leadPn.recruitment.roadshow_completed_date
      );
    },
    hasRoadshowScore() {
      return Boolean(
        this.hasRecruitment &&
          this.leadPn.recruitment.roadshow_classification
      );
    },
    hasInterviewScore() {
      return Boolean(
        this.hasRecruitment &&
          this.leadPn.recruitment.interview_classification
      );
    },
    canCreateAppointment() {
      return this.$can(CREATE_ACTION, APPOINTMENT);
    },
    canReadInterview() {
      return this.$can(READ_ACTION, INTERVIEW_RESOURCE);
    },
    canManageInterview() {
      return this.$can(MANAGE_ACTION, INTERVIEW_RESOURCE);
    },
    isOwnerDeleted() {
      return this.customer?.consultant_status === 4;
    },
    canViewReferrer() {
      // Apenas PN ou Admin podem ver quem indicou
      return (
        isPnRole(this.currentUser?.user_contract_type_id) ||
        isBackofficeRole(this.currentUser?.user_contract_type_id)
      );
    },
    canRequestSpecialist() {
      return this.$can(READ_ACTION, REQUEST_SPECIALIST_MENU);
    },
    hasRequestSpecialistRequests() {
      return Array.isArray(this.customer?.request_specialist_requests)
        && this.customer.request_specialist_requests.length > 0;
    },
    latestRequestSpecialistRequest() {
      if (!Array.isArray(this.customer?.request_specialist_requests)) {
        return null;
      }
      return this.customer.request_specialist_requests[0] || null;
    },
    showRequestPriorityAction() {
      return (
        this.profileType == this.type.PROFILE_TYPE_CUSTOMER &&
        this.canRequestSpecialist &&
        !!this.customer?.request_specialist_available
      );
    },
    interviewStatusData() {
      const arr = Array.isArray(this.customer?.interviews)
        ? this.customer.interviews
        : [];
      const interviewItem = arr.length ? arr[0] : null;

      if (!interviewItem) {
        return {
          interviewItem,
          statusLabel: "Não Preenchida",
          badgeVariant: "danger",
          status: "empty",
        };
      }

      if (interviewItem.is_interview === true) {
        return {
          interviewItem,
          statusLabel: "Preenchimento Completo",
          badgeVariant: "success",
          status: "complete",
        };
      }

      if (interviewItem.is_interview === false) {
        return {
          interviewItem,
          statusLabel: "Preenchida Parcialmente",
          badgeVariant: "warning",
          status: "partial",
        };
      }

      return {
        interviewItem,
        statusLabel: "Não Preenchida",
        badgeVariant: "danger",
        status: "empty",
      };
    },
  },
  mounted() {
    this.getProfileData();
  },
  watch: {
    // O customer chega async (getProfileData); busca o status da IA assim que o
    // token existir. Fail-open: erro deixa os botões de envio comuns visíveis.
    "customer.token": {
      immediate: true,
      handler(token) {
        const isCustomerOrLead =
          this.profileType == profileTypes.PROFILE_TYPE_CUSTOMER ||
          this.profileType == profileTypes.PROFILE_TYPE_LEAD;
        if (!token || !isCustomerOrLead) return;
        this.getAiPreInterviewStatus(token)
          .then((response) => {
            this.aiPreInterviewStatus = response.data;
          })
          .catch(() => {});
      },
    },
  },
  methods: {
    formatScore(value) {
      const number = Number(value);
      if (!Number.isFinite(number)) return "0";
      return Number.isInteger(number) ? String(number) : number.toFixed(1);
    },
    classificationTagVariant(tagName) {
      const normalized = (tagName || "").trim().toLowerCase();
      if (normalized === "alto potencial") return "success";
      if (normalized === "médio potencial" || normalized === "medio potencial")
        return "warning";
      if (normalized === "reprove imediatamente") return "danger";
      return null;
    },
    tagVariant(tagName) {
      if (this.isDesalinhamento(tagName)) return "danger";
      return this.classificationTagVariant(tagName) || "";
    },
    tagStyle(tagName) {
      if (this.isDesalinhamento(tagName) || this.classificationTagVariant(tagName)) {
        return "";
      }
      return "background-color: #316764; color: #f6f6f6";
    },
    ...mapActions({
      getCustomer: types.GET_CUSTOMER,
      getAiPreInterviewStatus: types.GET_AI_PRE_INTERVIEW_STATUS,
      sendWhatsappInterview: sharedTypes.SEND_INTERVIEW_WHATSAPP,
      sendInterviewEmail: sharedTypes.SEND_INTERVIEW_EMAIL,
      openUserPersonalDataSidebar: types.OPEN_USER_PERSONAL_DATA_SIDEBAR,
      openUserAddressSidebar: types.OPEN_USER_ADDRESS_SIDEBAR,
      updateProfilePic: types.UPDATE_CUSTOMER_PROFILE_PICTURE,
      getInterviewToken: sharedTypes.GET_INTERVIEW_TOKEN,
      setCustomerLeadStatus: leadTypes.SET_CUSTOMER_LEAD_STATUS,
      getCustomerTimelineEvents: types.GET_CUSTOMER_TIMELINE_EVENTS,
      convertToInterview: types.CONVERT_TO_INTERVIEW,
      openNewAppointmentSidebar: appointmentTypes.OPEN_NEW_APPOINTMENT_SIDEBAR,
      getXMomentPDF: sharedTypes.GET_BUSINESS_CONFIG_X_MOMENT_PDF,
      getLeadPn: types.GET_LEAD_PN,
      openNewLeadSidebar: leadTypes.OPEN_NEW_LEAD_SIDEBAR,
      openSaveConsultantBasicInformationSidebar:
        consultantTypes.OPEN_NEW_CONSULTANT_SIDEBAR,
      setCallReminder: SET_CALL_REMINDER,
      openLeadTagSidebar: recruitmentTypes.OPEN_LEAD_TAG_SIDEBAR,
      openRoadshowScoreReview:
        recruitmentTypes.OPEN_ROADSHOW_SCORE_REVIEW_SIDEBAR,
      getRoadshowMessage: sharedTypes.GET_ROADSHOW_MESSAGE,
      getInterviewBeingAccessed: types.GET_INTERVIEW_BEING_ACCESSED,
      getLeadPnIsDisqualified: types.GET_LEAD_PN_IS_DISQUALIFIED,
      reactivateLeadPn: types.REACTIVATE_LEAD_PN,
      hasOpenFinanceAccounts: types.HAS_OPEN_FINANCE_ACCOUNTS,
      deleteOpenFinanceAccounts: types.DELETE_OPEN_FINANCE_ACCOUNTS,
    }),
    openRequestSpecialistSidebar() {
      this.requestSpecialistSidebarVisible = true;
    },
    handleRequestSpecialistSidebarChange(visible) {
      this.requestSpecialistSidebarVisible = visible;
    },
    handleRequestSpecialistSidebarHidden() {
      this.requestSpecialistSidebarVisible = false;
    },
    handleRequestSpecialistSidebarRefresh() {
      this.getProfileData();
    },
    requestSpecialistStatusLabel(status) {
      return getRequestSpecialistStatusLabel(status);
    },
    requestSpecialistStatusVariant(status) {
      return getRequestSpecialistStatusVariant(status);
    },
    formatRequestSpecialistDateTime(value) {
      if (!value) {
        return "-";
      }

      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(value));
    },
    getProfileData() {
      this.loading = true;
      this.getCustomer(this.$route.params.id)
        .then((response) => {
          if (response.data && response.data.customer_additionals) {
            this.call_reminder =
              response.data.customer_additionals.call_reminder;
          }
          this.interviewStatus = this.interviewStatusData.status;
          this.isInterviewBeingAccessed();
          if (this.profileType == profileTypes.PROFILE_TYPE_CUSTOMER) {
            this.checkOpenFinance();
          }
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao obter as informações. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          // Só redireciona quando o registro de fato não existe/não é acessível;
          // em erro transitório (5xx/rede) o usuário permanece na tela.
          const status = error?.response?.status;
          if (status === 404 || status === 403) {
            if (this.profileType == profileTypes.PROFILE_TYPE_CUSTOMER) {
              this.$router.push({ name: "customers-list" });
            } else if (this.profileType == profileTypes.PROFILE_TYPE_LEAD) {
              this.$router.push({ name: "leads-customers-list" });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
      if (this.profileType == profileTypes.PROFILE_TYPE_CONSULTANT) {
        this.loading = true;
        this.getLeadPn(this.$route.params.id)
          .then((response) => {
            this.leadPn = response.data;
          })
          .catch(() => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao obter as informações. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.loading = false;
          });

        this.getLeadPnIsDisqualified(this.$route.params.id)
          .then((response) => {
            this.isLeadPnDisqualified = response.data.is_disqualified;
          })
          .catch(() => {
            this.isLeadPnDisqualified = false;
          });
      }
    },
    handleReactivateLeadPn() {
      this.$swal({
        title: "Reativar Lead PN?",
        text: "O lead será reinserido no recrutamento ativo e precisará preencher o RoadShow novamente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, reativar",
        cancelButtonText: "Cancelar",
        background: `${this.skin === "dark" ? "#283046" : ""}`,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-secondary ml-1",
          htmlContainer: `${this.skin === "dark" ? "text-white" : ""}`,
        },
      }).then((result) => {
        if (result.value) {
          this.reactivateLeadPn(this.customer.id)
            .then(() => {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Sucesso!",
                  text: "Lead PN reativado com sucesso.",
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              });
              this.getProfileData();
              this.getCustomerTimelineEvents(this.customer.id);
            })
            .catch(() => {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Oops!",
                  text: "Ocorreu um erro ao reativar o lead. Entre em contato com o setor de TI.",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
    sendInterviewByWhatsapp() {
      this.loadingSendInterviewByWhatsapp = true;
      this.sendWhatsappInterview(this.customer.token)
        .then((response) => {
          const message = createWppInterviewMessage(
            this.customer.name,
            this.customer.token,
            response.data.token_public
          );
          setTimeout(() => {
            window.open(
              `https://api.whatsapp.com/send?phone=${this.customer.cell_phone}&text=${message}`,
              "_blank"
            );
          });
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao enviar a mensagem. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loadingSendInterviewByWhatsapp = false;
        });
    },
    sendInterviewByEmail() {
      if (this.customer.email) {
        this.loadingSendInterviewByEmail = true;
        this.sendInterviewEmail(this.customer.token)
          .then((response) => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Sucesso!",
                text: "E-mail enviado com sucesso.",
                icon: "CoffeeIcon",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao enviar o email. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.loadingSendInterviewByEmail = false;
          });
      } else {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "O email para envio é inválido ou não existe. Por favor corrija o email antes de efetuar essa operação.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    generateXMoment() {
      this.getXMomentPDF().then((resp) => {
        setTimeout(() => {
          window.open(resp.data.value).focus();
        });
      });
    },
    openWhatsapp() {
      setTimeout(() => {
        window.open(`https://wa.me/${this.customer.cell_phone}`, "_blank").focus();
      });
    },
    sendEmail() {
      setTimeout(() => {
        window.open("mailto:" + this.customer.email, "_blank").focus();
      });
    },
    editPersonalData() {
      if (this.profileType == profileTypes.PROFILE_TYPE_CONSULTANT) {
        this.openEditLeadPntSidebar();
      } else {
        this.openUserPersonalDataSidebar({
          user: this.customer,
          saveAction: () => {
            this.getProfileData();
          },
        }).catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao editar os dados pessoais. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
      }
    },
    editAddress() {
      if (this.profileType == profileTypes.PROFILE_TYPE_CONSULTANT) {
        this.openEditLeadPntSidebar();
      } else {
        this.openUserAddressSidebar({
          user: this.customer,
          saveAction: () => {
            this.getProfileData();
          },
        }).catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao editar a localização. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
      }
    },
    uploadPic() {
      if (this.profilePic) {
        const request = new FormData();
        request.append("id", this.customer.id);
        request.append("picture", this.profilePic);
        this.updateProfilePic(request)
          .then((response) => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Sucesso",
                text: "Foto atualizada com sucesso!",
                icon: "CoffeeIcon",
                variant: "success",
              },
            });
            this.getProfileData();
          })
          .catch(() => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao salvar a fotos. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
      }
    },
    openInterview(edit) {
      this.getInterviewToken()
        .then((response) => {
          const accessToken = response.data;
          if (edit) {
            setTimeout(() => {
              window
                .open(
                  `${this.frontEndUrl}/autenticacao/${accessToken}?back_url=entrevista/${this.customer.token}`,
                  "_blank"
                )
                .focus();
            });
          } else {
            setTimeout(() => {
              window
                .open(
                  `${this.frontEndUrl}/autenticacao/${accessToken}?back_url=detalhe_entrevista/${this.customer.token}`,
                  "_blank"
                )
                .focus();
            });
          }
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao tentar acessar a entrevista. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    setStatus(new_status) {
      if (this.customer.customer_status_id == new_status) {
        new_status = customerStatus.CUSTOMER_STATUS_UNDEFINED;
      }
      if (this.canChangeStatus) {
        this.updateStatus(new_status);
      }
    },
    updateStatus(status_id) {
      this.setCustomerLeadStatus({
        customer_id: this.customer.id,
        status_id,
      })
        .then((response) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso!",
              text: "Atualizado com sucesso.",
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
          this.getProfileData();
          this.getCustomerTimelineEvents(this.customer.id).catch(() => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao carregar as atividades recentes. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao atualizar o status. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    convertInterview() {
      this.$swal({
        title: "Tem certeza?",
        text: "Após tranformar em entrevista o cliente não terá mais acesso, e não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        background: `${this.skin === "dark" ? "#283046" : ""}`,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-secondary ml-1",
          htmlContainer: `${this.skin === "dark" ? "text-white" : ""}`,
        },
      }).then((result) => {
        if (result.value) {
          this.convertToInterview(this.customer.token)
            .then((result) => {
              this.openInterview(true);
              this.reload();
            })
            .catch(() => {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Oops!",
                  text: "Ocorreu um erro ao tranformar em entrevista. Entre em contato com o setor de TI.",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
    createAppointment() {
      this.openNewAppointmentSidebar({
        customer_id: this.customer.id,
        saveAction: () => {
          this.reload();
          window.location.reload();
        },
      });
    },
    openEditLeadPntSidebar() {
      this.openNewLeadSidebar({
        id: this.customer.id,
        leadType: LEAD_TYPE_PPN,
        saveAction: () => {
          this.getProfileData();
          this.getCustomerTimelineEvents(this.customer.id).catch(() => {
            this.toast({
              component: ToastificationContent,
              props: {
                title: "Oops!",
                text: "Ocorreu um erro ao carregar as atividades recentes. Entre em contato com o setor de TI.",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          });
        },
      }).catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao editar as informações. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    },
    openNewConsultantSidebar() {
      this.openSaveConsultantBasicInformationSidebar({
        customer_id: this.customer.id,
      }).catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao tentar transformar o lead PN. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
    },
    saveCallReminder(date, customer_id) {
      this.setCallReminder({
        date,
        customer_id,
      })
        .then((response) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso!",
              text: "Atualizado com sucesso.",
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao escolher a data para lembrar. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    goToFinancialPlanning() {
      this.$router.push({
        name: "financial-planning",
        params: { id: this.customer.id },
      });
    },
    goToFinancialPromotions() {
      this.$router.push({
        name: "lead-pn-promotions",
        params: { id: this.customer?.id },
      });
    },
    editTags() {
      this.openLeadTagSidebar({
        customer_id: this.customer.id,
      });
    },
    isDesalinhamento(tagName) {
      return tagName?.toLowerCase().includes("desalinhamento");
    },
    async copyRoadshow() {
      try {
        const response = await this.getRoadshowMessage(this.customer.id);
        await navigator.clipboard.writeText(response.data.message);
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Sucesso",
            text: "Mensagem e links do RoadShow copiados com sucesso.",
            icon: "CoffeeIcon",
            variant: "success",
          },
        });
      } catch ($e) {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao copiar o link.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    openIndividualInterview() {
      this.$router.push({
        name: "individual-interview-report",
        params: { id: this.customer.id },
      });
    },
    openRoadshowScoreReviewSidebar() {
      this.openRoadshowScoreReview({
        customer_id: this.customer.id,
        saveAction: () => this.refreshLeadPn(),
      });
    },
    refreshLeadPn() {
      return this.getLeadPn(this.$route.params.id)
        .then((response) => {
          this.leadPn = response.data;
        })
        .catch(() => {});
    },
    isInterviewBeingAccessed() {
      this.getInterviewBeingAccessed(this.customer.token).then((response) => {
        this.interviewAccessBlocked = !response.data?.can_be_accessed || false;
      });
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.isInterviewBeingAccessed();
      }, 60000);
    },
    checkOpenFinance() {
      this.hasOpenFinanceAccounts(this.$route.params.id)
        .then((resp) => {
          this.hasOpenFinance = resp.data.has_open_finance;
        })
        .catch(() => {
          this.hasOpenFinance = false;
        });
    },
    confirmDeleteOpenFinance() {
      this.$swal({
        title: "Remover contas Open Finance?",
        text: "Esta ação irá remover permanentemente todas as contas Open Finance e os dados importados (transações e histórico). Não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, remover",
        cancelButtonText: "Cancelar",
        background: `${this.skin === "dark" ? "#283046" : ""}`,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary ml-1",
          htmlContainer: `${this.skin === "dark" ? "text-white" : ""}`,
        },
      }).then((result) => {
        if (result.value) {
          this.loadingDeleteOpenFinance = true;
          this.deleteOpenFinanceAccounts(this.$route.params.id)
            .then(() => {
              this.hasOpenFinance = false;
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Sucesso!",
                  text: "Contas Open Finance removidas com sucesso.",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
            })
            .catch(() => {
              this.toast({
                component: ToastificationContent,
                props: {
                  title: "Oops!",
                  text: "Ocorreu um erro ao remover as contas. Entre em contato com o setor de TI.",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            })
            .finally(() => {
              this.loadingDeleteOpenFinance = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.premium-separator {
  margin-top: 25px;
  margin-left: 2px;
  margin-bottom: 0;
}

.premium-star-icon {
  color: #dba800;
}

.premium-section-title {
  font-weight: 600;
  font-size: 0.85rem;
  color: #5e5873;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.premium-card {
  border-top: 2px solid #dba80044 !important;
}

.premium-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #b9b9c3;
  margin-bottom: 0.5rem;

  .feather {
    vertical-align: middle;
    margin-right: 3px;
  }
}

.premium-benefit-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.premium-benefit-item {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  font-size: 0.855rem;
  padding: 3px 0;
  color: #6e6b7b;

  .benefit-check {
    flex-shrink: 0;
  }

  &.extra .benefit-check {
    color: #7367f0;
  }
}

.premium-extra-remove {
  cursor: pointer;
  opacity: 0.55;
  line-height: 1;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;

  &:hover {
    opacity: 1;
    color: #ea5455;
  }
}

.premium-add-benefit {
  .b-input-group-append .btn {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 0.8rem;
  }
}

.premium-divider {
  margin: 1rem 0;
  border-color: rgba(110, 107, 123, 0.12);
}

.premium-amount-group {
  .input-group-text:last-child {
    font-size: 0.75rem;
    color: #b9b9c3;
    background: transparent;
  }
}

.premium-min-hint {
  font-size: 0.72rem;
  color: #b9b9c3;
}

.about-card {
  margin: unset !important;
}

.abbout-card-top {
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
}

.abbout-card-middle {
  border-radius: unset;
}

.abbout-card-bottom {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}

.card-separator {
  margin-top: 25px;
  margin-left: 2px;
  margin-bottom: 15px;
}

.tag-desalinhamento {
  box-shadow: 0 0 6px 2px rgba(228, 84, 85, 0.6);
  font-weight: bold;
}

@keyframes pulse-danger {
  0%,
  100% {
    box-shadow: 0 0 6px 2px rgba(228, 84, 85, 0.6);
  }
  50% {
    box-shadow: 0 0 12px 4px rgba(228, 84, 85, 0.9);
  }
}

#actions button {
  height: 35px !important;
}

.b-avatar-img {
  background-color: white;
}

.dark-layout.b-avatar-img {
  background-color: transparent;
}

body.dark-layout {
  .premium-section-title {
    color: #d0d2d6;
  }

  .premium-label {
    color: #d0d2d6;
  }

  .premium-benefit-item {
    color: #d0d2d6;
  }

  .premium-amount-group .input-group-text:last-child {
    color: #d0d2d6;
  }

  .premium-min-hint {
    color: #d0d2d6;
  }
}
</style>
<style lang="scss">
.profile .b-avatar-img {
  background-color: white;
}
body.dark-layout .profile .b-avatar-img {
  background-color: transparent;
}
.img_icon {
  width: 15px;
  height: 15px;
}
.vip-badge {
  border: solid 1px #dba800;
  background: unset;
}
.badge {
  margin-top: auto;
  margin-bottom: auto;
}

.router-link-active {
  font-weight: bold;
  color: #f26237;
  text-decoration: none;
}
</style>
